import React from 'react';
import type { FC } from 'react';
import type { BackOfficeExtensionContainer } from '@wix/extensions-data-client';
import type { ComponentGenerationResult } from '@wix/gena';
import { GenerationSuccessMessage } from '../../GenerationSuccessMessage.js';

export const DashboardPluginGeneratedNote: FC<{
  backofficeExtensionWidget: BackOfficeExtensionContainer;
  generatedFiles: ComponentGenerationResult['newFiles'];
}> = ({ generatedFiles }) => {
  return (
    <GenerationSuccessMessage
      extensionType={'dashboard plugin'}
      generatedFiles={generatedFiles}
      learnMoreUrl="https://dev.wix.com/docs/go-headless"
    />
  );
};
